import axios from "axios";
export default function setup(router) {
  axios.interceptors.response.use(
    (response) => {
      return response;
    },
    (err) => {
      if (err.response.status === 401) {
        console.log(err.response.status);
        const url = new URL(window.location.href);
        let redirect = url.searchParams.get('redirect');
        if(redirect) {
          router.push({
            path: "/",
            query: { redirect: redirect, logout: true } 
           })
        } else {
          router.push("/");
        }
      }
      if (err.response.data.message) {
        return Promise.reject(err.response.data.message); // Returns the error information returned by the interface
      } else {
        // Error handling when the return status code is not 200

        return Promise.resolve(err);
      }
    }
  );
}
